module.exports = __webpack_public_path__ + "img/Information-icon.4f2d65d7.png";